<ng-container *ngIf="isLoading">
  <div class="d-flex loading-wrapper">
    <div class="w-profile">
      <app-loader-spinner-general
        [loadingType]="LoadingType.PROFILE"
      ></app-loader-spinner-general>
    </div>
    <div class="w-info">
      <div class="w-first-row">
        <div>
          <app-loader-spinner-general
            [repeat]="3"
            [loadingType]="LoadingType.INFO"
          ></app-loader-spinner-general>
        </div>
        <div>
          <app-loader-spinner-general
            [repeat]="7"
            [loadingType]="LoadingType.INFO"
          ></app-loader-spinner-general>
        </div>
      </div>
      <app-loader-spinner-general
        [repeat]="2"
        [loadingType]="LoadingType.INFO"
      ></app-loader-spinner-general>
    </div>
  </div>
</ng-container>

<div class="details-body-wrapper" *ngIf="!isLoading && entity">
  <!-- 2 col details -->
  <div class="details-2c">
    <!-- left -->
    <app-company-card
      [entity]="entity"
      [entityType]="entityType"
      [service]="service"
      (changeCompany)="getEntityDetails()"
    ></app-company-card>
    <!-- end left -->

    <!-- right -->
    <div class="details-2c-right" *ngIf="entity">
      <div class="first-row">
        <section class="white-box-wrapper w-50">
          <app-company-primary-account
            [primaryAccount]="primaryAccount"
          ></app-company-primary-account>
        </section>
        <section class="white-box-wrapper w-50">
          <app-company-info
            [entity]="entity"
            [entityType]="entityType"
            [customer]="customer"
            [primaryAccount]="primaryAccount"
          ></app-company-info>
        </section>
      </div>
      <section class="white-box-wrapper">
        <app-assign-plan
          [entityType]="$any(entityType)"
          [entityId]="entityId"
        ></app-assign-plan>
      </section>
      <section class="white-box-wrapper">
        <app-ai-document-processing
          [entityType]="entityType"
          [entityId]="entityId"
        ></app-ai-document-processing>
      </section>
      <section class="white-box-wrapper">
        <app-chat-enabled
          [entityType]="entityType"
          [entityId]="entityId"
        ></app-chat-enabled>
      </section>
      <section class="white-box-wrapper">
        <app-account-scopes
          [entityType]="entityType"
          [entityId]="entityId"
        ></app-account-scopes>
      </section>
      <section class="white-box-wrapper" *ngIf="entityType === 'client'">
        <app-company-ebury-mapping
          [entityId]="entityId"
        ></app-company-ebury-mapping>
      </section>
      <section class="white-box-wrapper" *ngIf="entityType === 'client'">
        <app-company-account-managers
          [entityId]="entityId"
        ></app-company-account-managers>
      </section>
      <section
        class="white-box-wrapper ai-tokens-section"
        *ngIf="
          (entityType === 'client' || entityType === 'provider') && entity?.uuid
        "
      >
        <app-ai-entity-tokens
          [entityType]="entityType"
          [entityId]="entity.uuid"
        ></app-ai-entity-tokens>
      </section>
    </div>
    <!-- end right -->
  </div>
  <!-- end 2 col details -->
</div>
